module.exports = __webpack_public_path__ + "img/gn.f1d6c153.svg";